import React, { useState } from 'react';
import useFetchData from '../getJobs';
export const Context = React.createContext();

if (typeof window.kw_from_search === 'undefined') window.kw_from_search = "";

const Provider = props => {
    const [jobParams, setJobParams] = useState(0); //job params for search
    const {data, loading} = useFetchData(jobParams); 
    const [pageIndex, setPageIndex] = useState(1);  //sets the page num that the user is on
    const [inputs, setInputs] = useState({"keywords" : window.kw_from_search});
    const [modalJobSearchUsed, setModalJobSearchUsed] = useState(false)


    return (
      <Context.Provider
        value={{
          data,
          loading,
          jobParams,
          pageIndex,
          inputs,
          modalJobSearchUsed,
          updateJobParams: jobParams => setJobParams(jobParams),
          updatePageIndex: pageIndex => setPageIndex(pageIndex),
          updateInputs: inputs => setInputs(inputs),
          updateModalJobSearchUsed: modalJobSearchUsed => setModalJobSearchUsed(modalJobSearchUsed)
          
        }}
      >
        {props.children}
      </Context.Provider>
    );
  };
  
  export default Provider;
